import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import contactData from '../data/contact.json';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'Über uns' },
    { path: '/menu', label: 'Menü' },
    { path: '/gallery', label: 'Galerie' },
    { path: '/location', label: 'Standort' },
    { path: '/contact', label: 'Kontakt' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50" style={{ backgroundColor: '#1C1917', borderBottom: '1px solid rgba(247, 227, 154, 0.2)' }}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_74889022-3a14-4f9f-9a7b-69c3c5635b4b/artifacts/gipaf35k_Alibaba%20Logo.png" 
              alt="Ali Baba Logo" 
              className="h-14"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8 nav-font">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-[#F7E39A] ${
                  location.pathname === link.path ? 'text-[#F7E39A]' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Phone CTA */}
          <a 
            href={`tel:${contactData.restaurant.phone}`}
            className="hidden lg:flex items-center space-x-2 bg-[#F7E39A] text-[#1C1917] px-6 py-3 rounded-lg font-semibold transition-transform hover:scale-105"
          >
            <Phone size={18} />
            <span>{contactData.restaurant.phoneDisplay}</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <nav className="lg:hidden pb-6 nav-font">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block py-3 text-lg font-medium transition-colors ${
                  location.pathname === link.path ? 'text-[#F7E39A]' : 'text-white hover:text-[#F7E39A]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a 
              href={`tel:${contactData.restaurant.phone}`}
              className="flex items-center justify-center space-x-2 bg-[#F7E39A] text-[#1C1917] px-6 py-3 rounded-lg font-semibold mt-4"
            >
              <Phone size={18} />
              <span>{contactData.restaurant.phoneDisplay}</span>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
